import styled, { css } from 'styled-components';
import { AMZ_SUCCESS, NEGATIVE_500 } from '../../styles/colors';
import { IconFont } from '../../styles/font';
import { isAmazonHost } from '../../utils';

export type IconType = '\ue913' | '\ue947' | '\ue90b' | '\ue90c';

export const ICON_TYPES = {
  SUCCESS_AMZ: '\ue913' as IconType,
  NEGATIVE_AMZ: '\ue947' as IconType,
  SUCCESS: '\ue90b' as IconType,
  NEGATIVE: '\ue90c' as IconType,
} as const;

const ICON_STYLES = `
  ${IconFont}
  font-family: 'rs-iconfont';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
`;

export const Icon = styled.i<{ type: IconType }>`
  &&& {
    :before {
      content: '${({ type }) => type}';
      color: ${({ type }) =>
        type === ICON_TYPES.SUCCESS || type === ICON_TYPES.SUCCESS_AMZ
          ? AMZ_SUCCESS
          : NEGATIVE_500};
      ${ICON_STYLES}
    }
  }
`;

export const Coupon = styled.div`
  &&& {
    border-radius: 8px;
    padding: 16px 20px;
  }
`;

export const ResultQuestion = styled.div`
  &&& {
    &,
    * {
      font-size: 18px !important;
      line-height: 22px !important;
      margin: 0 !important;
    }
  }
`;

export const CouponDisclaimer = styled.div`
  &&& {
    &,
    * {
      font-size: 10px !important;
      line-height: 16px !important;
    }
  }
`;

export const ResultInfoBox = styled.div`
  &&& {
    > * {
      margin: 0;
    }
  }
`;

export const RingToOpen = styled.div`
  &&& {
    font-size: 14px !important;
    line-height: 24px !important;
    font-weight: 300;

    ${isAmazonHost() &&
    css`
      font-size: 12px !important;
      line-height: 16px !important;
      font-weight: 400;
    `}
  }
`;
